module.exports = __webpack_public_path__ + "img/default_user.4aa4dc7e.png";